<template>
  <div class="products w1320">
    <div class="title">
      <div class="cn">产品中心</div>
      <div class="en">Product Center</div>
    </div>
    <div class="container">
      <div class="left wow">
        <swiper :options="swiperOption1" ref="swiper1">
        <swiper-slide v-for="item in products" :key="item.ID">
          <div class="called">{{item.PRONAME}}</div>
          <div class="img"><img src="@/assets/images/p1.png" alt=""></div>
          <div class="content" v-html="item.MEMO"></div>
          <a class="btn" :href="item.LINK" target="_blank">View more</a>
        </swiper-slide>
      </swiper>
      </div>
      <div class="right">
        <div class="btn prev el-icon-arrow-left"></div>
        <div class="btn next el-icon-arrow-right"></div>
        <swiper :options="swiperOption2" class="swiper" ref="swiper2" @mouseover.native="hover" @mouseout.native="mouseout">
          <swiper-slide v-for="item in products" :key="item.ID">
            <img :src="`http://boyang.sansg.com/upload/${item.SMALLPIC}`" alt="">
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data(){
		return{
			swiperOption1:{
        notNextTick: true,
        loop: true,
        init:false
			},
			swiperOption2:{
        notNextTick: true,
        loop: true,
        init:false,
        effect : 'cube',
        navigation: {
          nextEl: '.products .container .right .btn.prev',
          prevEl: '.products .container .right .btn.next',
        },
        pagination : {
          el: '.products .swiper-pagination',
          clickable: true,
        },
        on:{
          setTranslate: (translate)=>{
            //自定义事件
            this.translate=translate
          },
        }
      },
      translate:0,
      products:[]
		}
  },
  mounted(){
    this.$nextTick(()=>{
      this.$refs.swiper1.swiper.controller.control=[this.$refs.swiper2.swiper]
      this.$refs.swiper2.swiper.controller.control=[this.$refs.swiper1.swiper]
    })
  },
  created(){
    this.getdata()
  },
  methods: {
    getdata(){
      this.$$axios.get('/php/products.php', {
        params: {
          tid: 63,
          num:10
        }
      })
      .then(res=>{
        this.products=res.data.proarr
      }).then(()=>{
        this.$refs.swiper1.swiper.init()
        this.$refs.swiper2.swiper.init()
      })
      .catch(error=>{
        console.log(error);
      });
    },
    hover(){
      this.$refs.swiper2.swiper.setTransition(1000)
      this.$refs.swiper2.swiper.setTranslate(this.translate-100)
    },
    mouseout(){
      this.$refs.swiper2.swiper.setTransition(1000)
      this.$refs.swiper2.swiper.setTranslate(this.translate+100)
    }
  }
}
</script>

<style scoped>
.products{
  padding: 175px 0;
}
.products .title{
  text-align: center;
  width: 472px;
  max-width: 100%;
}
.products .title .cn{
  font-family: '宋体';
  font-size: 30px;
  color: #5e7987;
  margin-bottom: 10px;
}
.products .title .en{
  font-family: 'Embassy BT';
  font-size: 20px;
  color: #636363;
}
.products .container{
  display: flex;
  align-items: flex-end;
}
.products .container .left{
  width: 43.4%;
  padding: 0 70px;
	animation-name: transition1;
	animation-duration: 1s;
  animation-fill-mode:forwards;
}
.products .container .left .called{
  text-align: center;
  font-size: 20px;
  font-weight: lighter;
}
.products .container .left .img{
  text-align: center;
}
.products .container .left .content{
  font-size: 12px;
  line-height: 30px;
  font-weight: lighter;
  margin-top: 30px;
}
.products .container .left .btn{
  position: relative;
  border: 1px solid #5e7987;
  text-align: center;
  display: block;
  width: 180px;
  margin: 0 auto;
  max-width: 100%;
  font-size: 14px;
  font-family: 'Century751';
  padding: 20px 0;
  cursor: pointer;
  margin-top: 70px;
  transition: 1s;
}
.products .container .left .btn:hover{
  background-color: #5e7987;
  color: #fff;
}
.products .container .right{
  width: 56.6%;
  padding-right: 75px;
  position: relative;
}
.products .container .right .btn{
  position: absolute;
  right: 30px;
  width: 75px;
  height: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  cursor: pointer;
  transition: 1s;
}
.products .container .right .btn:focus{
  outline: none;
}
.products .container .right .btn.prev{
  bottom: 75px;
}
.products .container .right .btn.next{
  bottom: 0;
}
.products .container .right .btn:hover{
  background-color: #7b929e;
  color: #fff;
}
.products .container .right .swiper{
  width: 520px;
  max-width: 100%;
}
.products .container .right .swiper .swiper-slide img{
  display: block;
  width: 100%;
}
@keyframes transition1 {
  0% {
    transform: translate(-100px,-100px);
    opacity: 0;
  }
  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}
@keyframes transition2 {
  0% {
    transform: translate(100px,-100px);
    opacity: 0;
  }
  100% {
    transform: translate(0,0);
    opacity: 1;
  }
}
@media(max-width: 768px){
  .products{
    padding: 50px 0;
  }
  .products .container{
    flex-wrap: wrap;
  }
  .products .container .left,
  .products .container .right{
    width: 100%;
  }
  .products .container .left{
    padding: 0 20px;
  }
  .products .container .left .called{
    margin: 20px 0;
  }
  .products .container .right{
    padding: 0 20px;
  }
  .products .container .right .btn{
    display: none;
  }
}
</style>


